<template>
  <router-link
    to="/create-agent"
    v-if="canCreateAgent"
    v-slot="{ href, navigate, isActive, isExactActive }"
  >
    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item"
      :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]"
    >
      <a :href="href" class="menu-link" @click="navigate">
        <i class="menu-icon fas fa-user-plus"></i>
        <span class="menu-text">Create Agent</span>
      </a>
    </li>
  </router-link>
</template>

<script>
export default {
  computed: {
    canCreateAgent() {
      // Solo Frontdesk (rol 5) y SuperAdmin (rol 1) pueden crear agentes
      const storedUser = localStorage.getItem('userData');
      if (!storedUser) return false;
      try {
        const parsed = JSON.parse(storedUser);
        const roles = parsed?.roles || [];
        return Array.isArray(roles) && roles.some(role => {
          const roleId = Number(role.id);
          return roleId === 5 || roleId === 1; // Frontdesk o SuperAdmin
        });
      } catch (error) {
        return false;
      }
    },
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
  },
};
</script>

<style></style>

